// extracted by mini-css-extract-plugin
export var container = "component-module--container--c9301";
export var dark = "component-module--dark--22fb2";
export var image = "component-module--image--6a533";
export var light = "component-module--light--329c2";
export var logos = "component-module--logos--59d78";
export var tagline = "component-module--tagline--ec3b0";